<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Criar tarefa - Empresa</h2>
        <p class="modal-subtitle">Preencha os campos para criar uma nova tarefa</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fechar.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <ng-container *ngIf="selecionarEmpresa; else empresaFixa">
      <div class="form-group">
        <label class="form-label" for="empresa">
          Empresa
          <span class="required">*</span>
        </label>

        <div class="autocomplete-wrapper">
          <input
            id="empresa"
            type="text"
            class="form-input"
            placeholder="Digite ao menos 3 letras do nome da empresa"
            [(ngModel)]="termoEmpresa"
            (ngModelChange)="aoDigitarEmpresa($event)"
            [class.form-input--error]="erro && !empresaId"
            autocomplete="off"
          />

          <ul class="autocomplete-lista" *ngIf="empresasEncontradas.length">
            <li *ngFor="let e of empresasEncontradas" (click)="selecionarEmpresaBusca(e)">
              <strong>{{ e.tradeName || e.name }}</strong>
              <small>{{ e.city }}/{{ e.state }} — {{ e.totalWorks }} obra(s)</small>
            </li>
          </ul>

          <span class="autocomplete-status" *ngIf="buscandoEmpresas">Buscando empresas...</span>
        </div>

        <span class="error-msg" *ngIf="erro && !empresaId">Selecione uma empresa</span>
      </div>

      <div class="form-group">
        <label class="form-label">
          Contatos
          <span class="required">*</span>
        </label>

        <p class="hint" *ngIf="!empresaId">Selecione uma empresa para ver os contatos.</p>

        <input
          *ngIf="empresaId && contatos.length"
          type="text"
          class="form-input busca-contatos"
          placeholder="Buscar contato pelo nome"
          [(ngModel)]="termoContato"
          autocomplete="off"
        />

        <div class="lista-contatos" *ngIf="empresaId">
          <span *ngIf="carregandoContatos" class="hint">Carregando contatos...</span>

          <label *ngFor="let c of contatosFiltrados" class="check-contato">
            <input
              type="checkbox"
              [checked]="contatosSelecionados.includes(c.id)"
              (change)="alternarContato(c.id)"
            />
            <span>{{ c.name }}</span>
          </label>

          <span *ngIf="!carregandoContatos && contatos.length && !contatosFiltrados.length" class="hint">
            Nenhum contato encontrado para "{{ termoContato }}".
          </span>

          <span *ngIf="!carregandoContatos && !contatos.length" class="hint">
            Esta empresa não possui contatos disponíveis.
          </span>
        </div>

        <span class="error-msg" *ngIf="erro && empresaId && !contatosSelecionados.length">
          Selecione ao menos um contato
        </span>

        <span class="hint" *ngIf="contatosSelecionados.length > 1">
          Será criada uma tarefa para cada contato selecionado.
        </span>
      </div>
    </ng-container>

    <ng-template #empresaFixa>
      <div class="info-empresa" *ngIf="empresaId">
        <span class="info-label">Empresa</span>
        <span class="info-valor">{{ empresaNome }}</span>
      </div>

      <div class="form-group">
        <label class="form-label">
          Contatos
          <span class="required">*</span>
        </label>
        <div class="chips">
          <span *ngFor="let c of contatos" class="chip">{{ c.name }}</span>
          <span *ngIf="!contatos.length" class="error-msg">Nenhum contato selecionado</span>
        </div>

        <span class="hint" *ngIf="contatos.length > 1">
          Será criada uma tarefa para cada contato selecionado.
        </span>
      </div>
    </ng-template>

    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="responsavel">
          Responsável
          <span class="required">*</span>
        </label>
        <select
          id="responsavel"
          class="form-select"
          [class.form-input--error]="erro && !responsibleID"
          [(ngModel)]="responsibleID"
        >
          <option value="" disabled>Selecione</option>
          <option *ngFor="let r of responsaveis" [value]="r.id">{{ r.name }}</option>
        </select>
        <span class="error-msg" *ngIf="erro && !responsibleID">Selecione</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="tarefa">
          Tipo de tarefa
          <span class="required">*</span>
        </label>
        <select
          id="tarefa"
          class="form-select"
          [class.form-input--error]="erro && !actionID"
          [(ngModel)]="actionID"
        >
          <option value="" disabled>Selecione</option>
          <option *ngFor="let a of acoes" [value]="a.actionId">{{ a.description }}</option>
        </select>
        <span class="error-msg" *ngIf="erro && !actionID">Selecione</span>
      </div>
    </div>

    <div class="form-row form-row--data">
      <div class="form-group">
        <label class="form-label" for="data">
          Data
          <span class="required">*</span>
        </label>
        <input
          id="data"
          type="date"
          class="form-input"
          [min]="dataMinima"
          [class.form-input--error]="erro && !data"
          [(ngModel)]="data"
          (ngModelChange)="aoAlterarData()"
        />
        <span class="error-msg" *ngIf="erro && !data">Informe a data</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="hora">
          Hora
          <span class="required">*</span>
        </label>
        <input
          id="hora"
          type="time"
          class="form-input"
          [min]="horaMinima"
          [class.form-input--error]="erro && !hora"
          [(ngModel)]="hora"
        />
        <span class="error-msg" *ngIf="erro && !hora">Informe a hora</span>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="descricao">Descreva a tarefa</label>
      <textarea
        id="descricao"
        class="form-textarea"
        rows="4"
        maxlength="2000"
        [(ngModel)]="description"
        placeholder="Adicione informações sobre a tarefa..."
      ></textarea>
      <div class="textarea-footer">
        <span class="char-count">{{ description.length }}/2000</span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="fechar.emit()">Cancelar</button>
    <button class="btn-primary" type="button" (click)="criar()" [disabled]="carregando">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      {{
        carregando
          ? 'Aguarde...'
          : totalContatosSelecionados > 1
            ? 'Criar ' + totalContatosSelecionados + ' tarefas'
            : 'Criar tarefa'
      }}
    </button>
  </div>
</div>
